<template>
  <div class="form-control input">
          <label for="username">Usuario</label>
          <input
            type="text"
            v-model="username"
            name="username"
            class="form-control"
            :class="{ 'is-invalid': submitted && !username }"
            v-on:change="(event) => this.$emit('inputChange', event)"/>
          <div v-show="submitted && !username" class="invalid-feedback">
            El usuario es obligatorio
          </div>
  </div>
</template>

<script>
export default {

props : ['submitted'],
 data() {         
    return {
      username: "",
      error: "",
      visibility: false,
      }
    }
}
</script>

<style>

</style>